import { render } from "./AllPageView.vue?vue&type=template&id=3cc22afc&scoped=true"
import script from "./AllPageView.vue?vue&type=script&lang=js"
export * from "./AllPageView.vue?vue&type=script&lang=js"

import "./AllPageView.vue?vue&type=style&index=0&id=3cc22afc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc22afc"]])

export default __exports__